import { API_KEY_ACCESS_LEVEL_NONE, API_KEY_LEVEL_THRESHOLDS } from './apiKeyPermissions.js';

/**
 * The access level a permission set derives to: the highest level whose fixed
 * threshold the set contains, else 'none'. The level is never chosen; every
 * write of a key's permissions stores this beside them.
 */
const deriveApiKeyAccessLevel = (permissionKeys) => {
  const held = new Set(permissionKeys || []);
  const reached = API_KEY_LEVEL_THRESHOLDS.find((threshold) => threshold.permissions.every((key) => held.has(key)));

  return reached ? reached.level : API_KEY_ACCESS_LEVEL_NONE;
};

export default deriveApiKeyAccessLevel;
